import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {fuseAnimations} from '@fuse/animations';
import {CategoryService} from "../../../services/category.service";
import {AlertService} from "../../../services";
import {NestedTreeControl} from "@angular/cdk/tree";
import {Category} from "../../../models/category";
import {MatTreeNestedDataSource} from "@angular/material/tree";

@Component({
    selector: 'report-main-sidebar',
    templateUrl: './main-sidebar.component.html',
    styleUrls: ['./main-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ReportMainSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    categories: any[];
    loadingIndicator: boolean;
    treeControl = new NestedTreeControl<Category>(node => node.children);
    dataSource = new MatTreeNestedDataSource<Category>();

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router,
        private categoryService: CategoryService,
        private alertService: AlertService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;
        this.dataSource.data = [];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.categoryService.getAllMainByType('resource').subscribe((res: any[]) => {
            this.categories = res;
            this.dataSource.data = res;
            this.loadingIndicator = false;
        }, error => {
            this.alertService.error(error);
        })
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New resource
     */
    newResource(): void {
        this._router.navigate(['/settings/resources/new']).then(() => {

        });
    }

    hasChild = (_: number, node: Category) => !!node.children && node.children.length > 0;

    filterListByCategory(id: string): void {
        console.log(id);
    }
}
